<ion-header class="balanced-title-header title-content-gap ion-no-border">
  <ion-toolbar class="header_toolbar">
    <div class="balanced-title-row">
      @if (nowStep > 1) {
        <ion-button class="balanced-title-back" fill="clear" aria-label="Back" (click)="goBack()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
      }
      <h1 class="balanced-title">{{nowStep === 7 ? 'My Team': 'Registration'}}</h1>
      @if (nowStep === 7) {
        <ion-button class="balanced-title-action" fill="clear" (click)="registerUserOnTheServer(true)">
          Skip
        </ion-button>
      } @else {
        <ion-button class="balanced-title-action" fill="clear" aria-label="Close" (click)="goToWelcomePage()">
          <ion-icon name="close-outline"></ion-icon>
        </ion-button>
      }
    </div>
  </ion-toolbar>
  <div class="progress-line-wrapper">
    <ion-row class="row-wrap" padding>
      @for (step of totalSteps; track step) {
        <ion-col [ngClass]="{'active-step': nowStep >= step}" ></ion-col>
      }
    </ion-row>
  </div>
</ion-header>

<ion-content class="registration-pages ion-padding" [fullscreen]="true">

  <!-- STEP 1 Date of Birth -->
  @if (nowStep === 1) {
    <h4 class="birth-header">What is your date of birth?</h4>
    <div class="item-wrapper" [ngClass]="{'data-invalid':!dobValidated}">
      <ion-item lines="none" class="dob-item" data-testid="registration-dob-open" (click)="openDobSheet()">
        <ion-label position="stacked" class="dob-label">Date of birth</ion-label>
        <ion-input
          class="dob-input"
          data-testid="registration-dob"
          readonly
          [value]="displayDob"
          placeholder="e.g. 28/12/1960">
        </ion-input>
      </ion-item>
    </div>
    <div class="additional-info">
      You must be 18+ to play Match15.
    </div>
  }

  <!-- STEP 2 Phone number -->
  @if (nowStep === 2) {
      <h4 class="birth-header">Enter your phone number</h4>
      <div class="phone-section-description">
        We will only use this if there are problems with your account. If you use a mobile number, we might be able to help you via text.
      </div>
      <div class="item-wrapper" [ngClass]="{'data-invalid':!PhoneValidated}">
        <ion-item class="login-form-item date-of-birth" no-lines >
          <ion-label position="stacked">Phone number</ion-label>
          <ion-input type="tel" [(ngModel)]="account.phone" name="phone" class="login-form-input passwordInput"
                     data-testid="registration-phone"
                     inputmode="numeric"
                     pattern="[0-9]*"
                     #phone="ngModel"
                     minLength="11"
                     placeholder="e.g. 07911123456"
                     (ionInput)="onPhoneInput($event)">
          </ion-input>
        </ion-item>
      </div>
      <div class="additional-info">
        Phone number format: 07911123456. <u>Please do not enter country code.</u>
      </div>
      @if (!this.PhoneValidated) {
        <div class="usernameTaken">
          Invalid phone number. Please check and try again.
        </div>
      }
  }


  <!-- STEP 3 Post code -->

  @if (nowStep === 3) {
    <h4 class="birth-header">You're almost registered. <br> We just need your address.</h4>
    @if (!this.showAddressSection) {
      <div class="postcode-wrapper">
        <div class="item-wrapper" [ngClass]="{'data-invalid':!tempPostcode}">
          <ion-item class="login-form-item date-of-birth" no-lines >
            <ion-label position="stacked">Postcode</ion-label>
            <ion-input type="text" [(ngModel)]="account.tempPostcode" (ionInput)="searchPostcode()" name="postCode" class="login-form-input passwordInput"
                       #tempPostcode="ngModel"
                       placeholder="Enter your postcode">
            </ion-input>
          </ion-item>
        </div>
        <div class="additional-info">
          Please enter the full Postcode and then choose your address from the list.
        </div>
        @if (searchListOfAddresses?.length) {
          <div class="listOfAddresses">
            @for (address of searchListOfAddresses; track address.id;) {
              <div class="address" (click)="selectAddress(address)">{{address?.building}}, {{address?.street}}, {{address?.town}}, {{address?.postcode}}</div>
            }
          </div>
        }
      </div>
    }

    @if (this.showAddressSection) {
      @if (!isManualEdit) {
        <div class="selectedAddress">
          <div class="backAddressButton" (click)="backToStartSearchPostcode();">
            <ion-icon name="refresh-outline"></ion-icon>
          </div>
          <div class="box_detailed_Address" [innerHTML]="temp_address_from_loqate"></div>
        </div>
      }
      <div class="enterManually" (click)="switchToManualEdit()">{{isManualEdit ? 'Back' : 'Enter Manually'}}</div>
      @if (isManualEdit) {
        <div >
          <br>
          <div class="item-wrapper" [ngClass]="{'data-invalid':!addressValidated}">
            <ion-item class="login-form-item date-of-birth" no-lines >
              <ion-label position="stacked">Building</ion-label>
              <ion-input type="text" [(ngModel)]="account.building" name="building" class="login-form-input"
                         #building="ngModel"
                         placeholder="Building">
              </ion-input>
            </ion-item>
          </div>
          <br>
          <div class="item-wrapper" [ngClass]="{'data-invalid':!addressValidated}">
            <ion-item class="login-form-item date-of-birth" no-lines >
              <ion-label position="stacked">Street</ion-label>
              <ion-input type="text" [(ngModel)]="account.street" name="street" class="login-form-input"
                         #street="ngModel"
                         placeholder="Street">
              </ion-input>
            </ion-item>
          </div>
          <br>
          <div class="item-wrapper" [ngClass]="{'data-invalid':!cityValidated}">
            <ion-item class="login-form-item date-of-birth" no-lines >
              <ion-label position="stacked">Town</ion-label>
              <ion-input type="text" [(ngModel)]="account.city" name="city" class="login-form-input"
                         #city="ngModel"
                         placeholder="Town">
              </ion-input>
            </ion-item>
          </div>
          <br>
          <div class="item-wrapper" [ngClass]="{'data-invalid':!postcodeValidated}">
            <ion-item class="login-form-item date-of-birth" no-lines >
              <ion-label position="stacked">Postcode</ion-label>
              <ion-input type="text" [(ngModel)]="account.postcode" name="postcode" class="login-form-input"
                         #postcode="ngModel"
                         placeholder="Postcode">
              </ion-input>
            </ion-item>
          </div>
        </div>
      }

    }
  }

  <!-- STEP 4 Post code -->
  @if (nowStep === 4) {
    <h4 class="birth-header">Enter your first and lastname</h4>
    <div class="item-wrapper" [ngClass]="{'data-invalid':!firstNameValidated}">
      <ion-item class="login-form-item date-of-birth" no-lines >
        <ion-label position="stacked">First name</ion-label>
        <ion-input type="text" [(ngModel)]="account.first_name" name="first_name" class="login-form-input passwordInput"
                   #names="ngModel"
                   placeholder="e.g Marcus">
        </ion-input>
      </ion-item>
    </div>
    <br />
    <div class="item-wrapper" [ngClass]="{'data-invalid':!lastNameValidated}">
      <ion-item class="login-form-item date-of-birth" no-lines >
        <ion-label position="stacked">Last name</ion-label>
        <ion-input type="text" [(ngModel)]="account.last_name" name="last_name" class="login-form-input passwordInput"
                   #names="ngModel"
                   placeholder="e.g Jackson">
        </ion-input>
      </ion-item>
    </div>
    <div class="additional-info">
      We don't need any middle names.
    </div>
  }


  <!-- STEP 5 Username -->
  @if (nowStep === 5) {
    <h4 class="birth-header">Choose a unique username.</h4>
    <div class="phone-section-description">
      This is the name players will know you as in chat and on our winners board.
    </div>
    <div class="item-wrapper" [ngClass]="{'data-invalid':!usernameValidated}">
      <ion-item class="login-form-item date-of-birth" no-lines >
        <ion-label position="stacked">Username</ion-label>
        <ion-input type="text" [(ngModel)]="account.username" name="username" class="login-form-input passwordInput"
                   #username="ngModel"
                   placeholder="e.g SilverHand">
        </ion-input>
      </ion-item>
    </div>
    @if (!usernameIsTaken) {
      <div class="additional-info">
        Username should not be your email.
      </div>
    }
    @if (usernameIsTaken) {
      <div class="usernameTaken">
        Sorry! That username's already taken. <br> Please try again.
      </div>
    }
  }

  <!-- STEP 6 Password -->
  @if (nowStep === 6) {
    <h4 class="birth-header">Finally, enter a password, you will need this to login</h4>
    <form id="registration-password-form" autocomplete="on">
      <input
        type="email"
        name="username"
        autocomplete="username"
        [value]="account.email"
        hidden>
      <div class="item-wrapper" >
        <ion-item class="login-form-item" no-lines>
          <ion-label position="stacked">Password</ion-label>
          <ion-input #inputToFocus  class="login-form-input passwordInput"
                     id="new-password"
                     [type]="passwordType"
                     autocomplete="new-password"
                     [(ngModel)]="account.password"
                     name="password"
                     #userPassword="ngModel"
                     required
                     placeholder="Enter your password"
                     clearOnEdit="false"
                     (focus)="setCaretPosition($event)"
          >
          </ion-input>
          <!--          <button ion-button>-->
  <!--        <ion-icon [name]="passwordIcon"></ion-icon>-->
          <ion-button type="button" slot="end" size="small" class="passwordIcon" (click)='hideShowPassword($event)'>
            <ion-icon [name]="passwordIcon"></ion-icon>
          </ion-button>
          <!--          </button>-->

        </ion-item>
      </div>
    </form>
    <div class="additional-info">
      Password must be at least 10 characters long and include at least one uppercase letter, one lowercase letter, and one number.
    </div>
  }

  @if (nowStep === 7) {
    <div class="phone-section-description ion-text-center">
      Tell us your favourite team to be notified of their upcoming matches and to automatically purchase up to five cards for each of their matches.
    </div>
    <h4 class="step7-my-team-header">Select Your Team</h4>
    <ion-item class="select-team-item" [detail]="true" (click)="openTeamPicker()" lines="none">
      <ion-label>{{selectedTeam ? selectedTeam.name : 'Select Your Team'}}</ion-label>
    </ion-item>
  }


</ion-content>

@if (showLoader) {
  <div class="loader">
    <ion-icon class="su_spinner" src="../assets/icons/spinWhite.svg"></ion-icon>
  </div>

}

<ion-footer class="onboarding-footer">
  <ion-toolbar>
    <!-- Step 1 marketing opt-in: kept in the footer so it stays above the Next button -->
    @if (nowStep === 1 && account.marketing_opt_in === undefined) {
      <div class="marketing-section marketing-section-sticky">
        Say yes to opt into direct marketing and hear from Match15 about promotions and offers. You can withdraw your consent at any time via your preferences.
        <ion-row class="yesNoRow">
          <ion-col class="noCol">
            <button ion-button="" block class="popup-button" data-testid="registration-marketing-no" (click)="saveMarketingAction('no');">No</button>
          </ion-col>
          <ion-col class="yesCol">
            <button ion-button="" block class="popup-button highlightedYes" data-testid="registration-marketing-yes" [ngClass]="{'activeButtonCol': marketingButtonActive === 'yes'}" (click)="saveMarketingAction('yes');">Yes</button>
          </ion-col>
        </ion-row>
      </div>
    }
    <div class="next-button footer-buttons ion-text-center">
      <button class="popup-button footer-buttons" data-testid="registration-next" [disabled]="disableNextButton()" (click)="goNextStep()" >{{this.nowStep < 7 ? 'Next' : 'Submit'}}</button>
    </div>
  </ion-toolbar>
</ion-footer>

<ion-modal
  [isOpen]="dobOpen"
  (didDismiss)="dobOpen = false"
  [breakpoints]="[0, 0.33]"
  [initialBreakpoint]="0.33"
  [backdropDismiss]="false"
  [canDismiss]="canDismiss"
  class="dob-sheet"
>
  <ng-template>

    <!-- Верхні кнопки -->
    <ion-header class="dob-header">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button fill="clear" class="dob-cancel" (click)="onCancel()">CANCEL</ion-button>
          <ion-button fill="clear" class="dob-done"   (click)="onSave()">DONE</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="dob-content" force-overscroll="false">
      <ion-datetime
        #dobDt
        class="dob-datetime"
        data-testid="registration-dob-picker"
        presentation="date"
        preferWheel="true"
        [showDefaultButtons]="false"
      locale="en-GB"
      [min]="'1900-01-01'"
      [max]="maxDate"
      [value]="initialDate"
      (ionChange)="onDobPicked($event)"
      (ionCancel)="dobOpen = false"
      ></ion-datetime>
    </ion-content>

  </ng-template>
</ion-modal>
